import { ScorecardsPhaseSchema, type ScorecardsPhase } from '../api-client/api-schemas.ts'

/**
 * How a scorecard run's phase reads to a person, in one place.
 *
 * Shared rather than duplicated because the same run is reported in two surfaces at once — the
 * repository's own Scorecard tab and its row on the repositories page — and a reader moving between
 * them should see the same words for the same state. Two copies would drift the moment the backend
 * adds a phase.
 */
export const SCORECARDS_PHASES = ScorecardsPhaseSchema.options

export const SCORECARDS_PHASE_LABELS = {
  queued: 'Queued',
  fetching_code: 'Fetching code',
  loading_threat_model: 'Loading threat model',
  scoring_dimensions: 'Scoring dimensions',
  finalizing: 'Finalizing',
} satisfies Record<ScorecardsPhase, string>
